import React, { Component } from "react";
import { connect } from "react-redux";
import { Segment, Grid, Table } from "semantic-ui-react";
import _ from "lodash";
import ReportSummary from "../ReportSummary";
import PhysicalDescNimbus from "./PhysicalDescNimbus";
import AliasesDetailNimbus from "../AliasesDetailNimbus";
import PrintReportCaseHeader from "../PrintReportCaseHeader";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";
import CriminalRecordsNimbus from "./CriminalRecordsNimbus";
import ArrestRecordsNimbus from "./ArrestRecordsNimbus";
import WarrantRecordsNimbus from "./WarrantRecordsNimbus";

class CriminalMultiSectionNimbusReport extends Component {

  state = {
    activeIndex: 0,
  };

  onReportIndexChanged = (currentIndex) => {
    this.setState({
      activeIndex: currentIndex,
    });
    const element = document.getElementById(`acc_${currentIndex}`);
    element.scrollIntoView();
  };

  onReportPrint = () => {
    const accordionIndexes = this.state.accordionIndexes;
    _.forEach(accordionIndexes, (acc, accIndex) => {
      accordionIndexes[accIndex] = true;
    });
    this.setState({ accordionIndexes });
  };

  onReportPrint = () => {
    const accordionIndexes = this.state.accordionIndexes;
    _.forEach(accordionIndexes, (acc, accIndex) => {
      accordionIndexes[accIndex] = true;
    });
    this.setState({ accordionIndexes });
  };

  handleClick = (e, index) => {
    const { activeIndex } = this.state;
    const newIndex = activeIndex === index ? -1 : index;
    this.setState({ activeIndex: newIndex });
  };

  loadData = (props, isReload = false) => {
    const recs = [];
    const records = [];
    const accordionIndexes = [];
    if (props.reportData !== undefined) {
      _.forEach(
        _.get(props.reportData, "inmateReport.criminal"),
        (record, index) => {
          records.push(record);
          accordionIndexes.push(false);
          const suspect = _.get(record, "suspect[0]");
          const fullName = `${_.get(suspect, "name[0].firstName[0]._", "")} ${_.get(
            suspect,
            "name[0].middleName[0]._",
            ""
          )} ${_.get(suspect, "name[0].lastName[0]._", "")}`;
          const rows = [];
          rows.push(
            <Table.Row id={`row_${index}`} key={`row_${index}`}>
              <Table.Cell>
                <PhysicalDescNimbus node={suspect} {...props} />
                <AliasesDetailNimbus
                  showAkas
                  node={record}
                />
                <CriminalRecordsNimbus node={record.crimeDetailsRecords[0].crimeDetails} {...props} />
              </Table.Cell>
            </Table.Row>
          );
          recs.push(
            <SimpleAccordionContent
              {...this.props}
              name={fullName}
              rows={rows}
              key={`acc_${index}`}
              accId={`acc_${index}`}
            />
          );
        }
      );
      if (accordionIndexes.length > 0) accordionIndexes[0] = true;
    }
    if (!isReload) {
      this.setState({
        activeIndex: this.state.activeIndex,
        records,
        rows: recs,
        accordionIndexes,
      });
    } else {
      this.setState({
        activeIndex: this.state.activeIndex,
        records,
        rows: recs,
        accordionIndexes,
      });
    }
  };

  render() {
    const records = [];
    const nodes = [];
    let actId;
    if (this.props.reportData !== undefined) {
      actId = _.get(
        this.props.reportData,
        `${Object.keys(this.props.reportData)[0]}.log[0].actID[0]`
      );
      _.forEach(
        _.get(this.props.reportData, "inmateReport.criminal"),
        (record, index) => {
          nodes.push(record.suspect[0].name[0]);
          const suspect = _.get(record, "suspect[0]");
          const fullName = `${_.get(suspect, "name[0].firstName[0]._", "")} ${_.get(
            suspect,
            "name[0].middleName[0]._",
            ""
          )} ${_.get(suspect, "name[0].lastName[0]._", "")}`;
          const rows = [];
          rows.push(
            <Table.Row id={`row_${index}`} key={`row_${index}`}>
              <Table.Cell>
                <PhysicalDescNimbus node={suspect} {...this.props} />
                <AliasesDetailNimbus
                  showAkas
                  node={suspect}
                />
                <CriminalRecordsNimbus node={record.crimeDetailsRecords[0].crimeDetails} {...this.props} />
                <ArrestRecordsNimbus node={record.arrestDetailsRecords[0].crimeDetails} {...this.props} />
                <WarrantRecordsNimbus node={record.warrantDetailsRecords[0].crimeDetails} {...this.props} />
              </Table.Cell>
            </Table.Row>
          );
          records.push(
            <SimpleAccordionContent
              {...this.props}
              name={fullName}
              rows={rows}
              key={`acc_${index}`}
              accId={`acc_${index}`}
            />
          );
        }
      );
    }

    return (
      <Segment key="tabContent1" attached id={`report`}>
        <Grid columns={2} stackable>
          <Grid.Row>
            <Grid.Column width={16}>
              <Table className={`no-print`}>
                <Table.Body>
                  <PrintReportCaseHeader
                    {...this.props}
                    actId={actId}
                    onReportPrint={this.onReportPrint}
                  />
                </Table.Body>
              </Table>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={4}>
              <ReportSummary
                onReportIndexChanged={this.onReportIndexChanged}
                records={nodes}
                activeSummaryIndex={this.state.activeIndex}
              />
            </Grid.Column>
            <Grid.Column width={12}>
              {/* <Accordion fluid styled> */}
              {records}
              {/* </Accordion> */}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

function mapStateToProps(state) {
  return { userAccount: state.userAccount };
}

export default connect(mapStateToProps, null)(CriminalMultiSectionNimbusReport);



// WEBPACK FOOTER //
// ./src/components/reports/Criminal/CriminalMultiSectionNimbusReport.js